const LightSimple = ({position, intValue, distance}) => {

  return (
    <>
      <pointLight
        color="#fff"
        intensity={intValue ? intValue : 20.8}
        distance={distance ? distance : 40}
        decay={2}
        position={position}
        castShadow={true}
      />
      <mesh position={position}>
        <sphereGeometry args={[0.001, 16, 16]} />
        <meshStandardMaterial color="red" />
      </mesh>
    </>
  )
}

export {
  LightSimple
}